export default __webpack_public_path__ + "static/media/ic_delete_48px.3d9e4805.svg";